// extracted by mini-css-extract-plugin
export default {"fileIndexContainer":"ErrorObj_fileIndexContainer__J6iV6","fileIndexTitle":"ErrorObj_fileIndexTitle__a5HP8"};